'use client';

import * as React from 'react';
import { permanentRedirect } from 'next/navigation';
import { isEnvDev } from 'utils';

export type DomainRedirectProps = {
  customDomain?: string | null;
};

export function DomainRedirect({
  customDomain,
}: DomainRedirectProps): JSX.Element {
  React.useEffect(() => {
    if (isEnvDev) {
      return;
    }
    if (customDomain && customDomain !== location.hostname) {
      const url = new URL(location.href);
      url.hostname = customDomain;
      permanentRedirect(url.href);
    }
  }, [customDomain]);
  return <></>;
}
